import e, { createContext as n, useContext as r, useState as t, useReducer as o, useEffect as i, useCallback as u, useMemo as l } from "react";
import a from "@kinde-oss/kinde-auth-pkce-js";
var _c = function c() {
  return _c = Object.assign || function (e) {
    for (var n, r = 1, t = arguments.length; r < t; r++) {
      for (var o in n = arguments[r]) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }
    return e;
  }, _c.apply(this, arguments);
};
function s(e, n, r, t) {
  return new (r || (r = Promise))(function (o, i) {
    function u(e) {
      try {
        a(t.next(e));
      } catch (e) {
        i(e);
      }
    }
    function l(e) {
      try {
        a(t.throw(e));
      } catch (e) {
        i(e);
      }
    }
    function a(e) {
      var n;
      e.done ? o(e.value) : (n = e.value, n instanceof r ? n : new r(function (e) {
        e(n);
      })).then(u, l);
    }
    a((t = t.apply(e, n || [])).next());
  });
}
function f(e, n) {
  var r,
    t,
    o,
    i,
    u = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return i = {
    next: l(0),
    throw: l(1),
    return: l(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;
  function l(l) {
    return function (a) {
      return function (l) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; i && (i = 0, l[0] && (u = 0)), u;) {
          try {
            if (r = 1, t && (o = 2 & l[0] ? t.return : l[0] ? t.throw || ((o = t.return) && o.call(t), 0) : t.next) && !(o = o.call(t, l[1])).done) return o;
            switch (t = 0, o && (l = [2 & l[0], o.value]), l[0]) {
              case 0:
              case 1:
                o = l;
                break;
              case 4:
                return u.label++, {
                  value: l[1],
                  done: !1
                };
              case 5:
                u.label++, t = l[1], l = [0];
                continue;
              case 7:
                l = u.ops.pop(), u.trys.pop();
                continue;
              default:
                if (!(o = u.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== l[0] && 2 !== l[0])) {
                  u = 0;
                  continue;
                }
                if (3 === l[0] && (!o || l[1] > o[0] && l[1] < o[3])) {
                  u.label = l[1];
                  break;
                }
                if (6 === l[0] && u.label < o[1]) {
                  u.label = o[1], o = l;
                  break;
                }
                if (o && u.label < o[2]) {
                  u.label = o[2], u.ops.push(l);
                  break;
                }
                o[2] && u.ops.pop(), u.trys.pop();
                continue;
            }
            l = n.call(e, u);
          } catch (e) {
            l = [6, e], t = 0;
          } finally {
            r = o = 0;
          }
        }
        if (5 & l[0]) throw l[1];
        return {
          value: l[0] ? l[1] : void 0,
          done: !0
        };
      }([l, a]);
    };
  }
}
var d = {
    isAuthenticated: !1,
    isLoading: !0
  },
  g = n(_c({}, d)),
  v = function v() {
    var e = r(g);
    if (void 0 === e) throw new Error("Oooops! useKindeAuth must be used within a KindeProvider");
    return e;
  },
  h = {
    INITIALISED: function INITIALISED(e, n) {
      return _c(_c({}, e), {
        isAuthenticated: Boolean(n.user),
        user: n.user,
        isLoading: !1,
        error: void 0
      });
    },
    LOGOUT: function LOGOUT(e) {
      return _c(_c({}, e), {
        isAuthenticated: !1,
        user: void 0
      });
    },
    ERROR: function ERROR(e, n) {
      return _c(_c({}, e), {
        isLoading: !1,
        error: n.error
      });
    }
  },
  p = function p(e, n) {
    return h[n.type] ? h[n.type](e, n) : e;
  },
  y = function y() {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  m = function m(n) {
    var r = n.audience,
      v = n.scope,
      h = n.clientId,
      m = n.children,
      w = n.domain,
      b = n.isDangerouslyUseLocalStorage,
      k = void 0 !== b && b,
      O = n.redirectUri,
      I = n.onRedirectCallback,
      _ = void 0 === I ? y : I,
      P = n.onErrorCallback,
      U = n.logoutUri,
      E = t(),
      F = E[0],
      R = E[1],
      S = o(p, d),
      T = S[0],
      L = S[1];
    i(function () {
      try {
        s(void 0, void 0, void 0, function () {
          var e;
          return f(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, a({
                  audience: r,
                  scope: v,
                  client_id: h,
                  domain: w,
                  is_dangerously_use_local_storage: k,
                  redirect_uri: O,
                  logout_uri: U,
                  on_redirect_callback: _,
                  on_error_callback: P,
                  _framework: "React",
                  _frameworkVersion: "4.0.4"
                })];
              case 1:
                return e = n.sent(), R(e), [2];
            }
          });
        });
      } catch (e) {
        console.error(e);
      }
      return function () {};
    }, [r, v, h, w, k, O, U]), i(function () {
      var e = !0;
      return function () {
        if (F && e) try {
          var n = null == F ? void 0 : F.getUser();
          L({
            type: "INITIALISED",
            user: n
          });
        } catch (e) {
          console.log(e), L({
            type: "ERROR",
            error: "login error"
          });
        }
      }(), function () {
        e = !1;
      };
    }, [F]);
    var x = u(function (e) {
        return (null == F ? void 0 : F.login(e)) || Promise.resolve();
      }, [F]),
      A = u(function (e) {
        return (null == F ? void 0 : F.register(e)) || Promise.resolve();
      }, [F]),
      z = u(function () {
        return (null == F ? void 0 : F.logout()) || Promise.resolve();
      }, [F]),
      C = u(function (e, n) {
        return (null == F ? void 0 : F.getClaim(e, n)) || null;
      }, [F]),
      j = u(function (e, n, r) {
        return (null == F ? void 0 : F.getFlag(e, n, r)) || n;
      }, [F]),
      B = u(function (e, n) {
        return (null == F ? void 0 : F.getBooleanFlag(e, n)) || n || !1;
      }, [F]),
      D = u(function (e, n) {
        return (null == F ? void 0 : F.getIntegerFlag(e, n)) || n;
      }, [F]),
      G = u(function (e, n) {
        return (null == F ? void 0 : F.getStringFlag(e, n)) || n;
      }, [F]),
      K = u(function () {
        return null == F ? void 0 : F.getPermissions();
      }, [F]),
      N = u(function (e) {
        return null == F ? void 0 : F.getPermission(e);
      }, [F]),
      V = u(function () {
        return null == F ? void 0 : F.getOrganization();
      }, [F]),
      q = u(function () {
        return null == F ? void 0 : F.getUserOrganizations();
      }, [F]),
      H = u(function (e) {
        return (null == F ? void 0 : F.createOrg(e)) || Promise.resolve();
      }, [F]),
      J = u(function (e) {
        return s(void 0, void 0, void 0, function () {
          var n, r;
          return f(this, function (t) {
            switch (t.label) {
              case 0:
                return t.trys.push([0, 2,, 3]), [4, null == F ? void 0 : F.getToken(e)];
              case 1:
                return n = t.sent(), [3, 3];
              case 2:
                throw r = t.sent(), console.error(r);
              case 3:
                return [2, n];
            }
          });
        });
      }, [F]),
      M = u(function (e) {
        return s(void 0, void 0, void 0, function () {
          var n, r;
          return f(this, function (t) {
            switch (t.label) {
              case 0:
                return t.trys.push([0, 2,, 3]), [4, null == F ? void 0 : F.getIdToken(e)];
              case 1:
                return n = t.sent(), [3, 3];
              case 2:
                throw r = t.sent(), console.error(r);
              case 3:
                return [2, n];
            }
          });
        });
      }, [F]),
      Q = u(function () {
        return (null == F ? void 0 : F.getUser()) || void 0;
      }, [F]),
      W = l(function () {
        return _c(_c({}, T), {
          getToken: J,
          getIdToken: M,
          login: x,
          register: A,
          logout: z,
          createOrg: H,
          getBooleanFlag: B,
          getClaim: C,
          getFlag: j,
          getIntegerFlag: D,
          getPermissions: K,
          getPermission: N,
          getOrganization: V,
          getStringFlag: G,
          getUserOrganizations: q,
          getUser: Q
        });
      }, [T, J, M, x, A, z, H, C, K, N, V, q, Q]);
    return e.createElement(g.Provider, {
      value: W
    }, m);
  };
export { m as KindeProvider, v as useKindeAuth };